import type { Action } from "../../actions/types";

export type StoreState = string;

export const initialState = "desktop";

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (action.type === "SET_DISPLAY_SIZE") {
    return action.data;
  }

  return state;
}
